import { Crypt } from 'hybrid-crypto-js';

export function encryption(password) {
  const publicKey = process.env.REACT_APP_PUBLIC_KEY;
  const crypt = new Crypt();
  const encrypted = crypt.encrypt(publicKey, password);
  return encrypted.toString();
}
